import collectionMethods from './view_case_details_collection_methods';
import riskMethods from './view_case_details_risk_methods';
import slaMethods from './view_case_details_sla_methods';
import statusMethods from './view_case_details_status_methods';

export default {
  ...riskMethods,
  ...collectionMethods,
  ...slaMethods,
  ...statusMethods,
};
